import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/home/Home";
import AttendanceFeedback from "./pages/feedback/AttendanceFeedback";
import Mystudent from "./pages/my_student/MyStudents";
import Campaigns from "./pages/campaigns/Campaigns";
import Overview from "./pages/overview/Overview";
import Staff from "./pages/staff/Staff.tsx";
import Attendance from "./pages/attendance/Attendance";
import Money from "./pages/money/Money";
import Profile from "./pages/profile/Profile";
import Settings from "./pages/settings/Settings";
import Student from "./pages/student/Student";
import Students from "./pages/students/Students";
import Owed from "./pages/owed/Owed";

import Loading from "./Loading";
import NewCustomer from "./pages/newcustomer/NewCustomer";
import Customer from "./pages/customer/Customer";
import NewStudent from "./pages/newstudent/NewStudent";
import StaffShifts from "./pages/shifts/StaffShifts";
import Absent from "./pages/absent/Absent";
import NoShows from "./pages/noshows/NoShows";
import PaymentHistory from "./pages/customer/components/PaymentHistory";
import StaffMember from "./pages/staff/StaffMember";
import HtClass from "./pages/class/HtClass";
import NewLostStudents from "./pages/newLostStudents/NewLostStudents";
import Accounting from "./pages/accounting/Accounting";
import MakeUpClasses from "./pages/makeUpClasses/MakeUpClasses";
import ManageMessages from "./pages/manageMessages/ManageMessages";
import SalesMessages from "./pages/salesMessages/SalesMessages";
import ClassesReport from "./pages/reports/ClassesReport";
import Salaries from "./pages/salaries/Salaries";
import SalesStudents from "./pages/salesStudents/SalesStudents";
import PaymentFrequency from "./pages/paymentFrequency/PaymentFrequency";
import TimeTable from "./pages/makeUpClasses/TimeTable";
import MakeUpClassDetails from "./pages/makeUpClasses/MakeUpClassDetails";



import Billing from "./pages/accounting/Billing";
import Users from "./pages/users/Users";


import StaffList from "./pages/owner/staffList/StaffList";
import OrgTree from "./pages/owner/orgtree/OrgTree";
import ColdData from "./pages/coldData/ColdData";
import ManageFeedback from "./pages/managefeedback/ManageFeedback";
import Pending from "./pages/pending/Pending";

import RevenueToday from "./pages/revenueToday/RevenueToday";
import Absent2 from "./pages/absent/Absent2";
import NeedMakeUp from "./pages/needMakeUpClasses/NeedMakeUp";
import StudentChanges from "./pages/studentChanges/StudentChanges";
import ReadyForClass from "./pages/readyForClass/ReadyForClass";
import PlacementTests from "./pages/placementTests/PlacementTests";
import Costs from "./pages/costs/Costs";
import Overview2 from "./pages/overview2/Overview2";
import SalaryStat from "./pages/overview2/SalaryStat";
import ExtraClass from "./pages/extraClass/ExtraClass";
import CLesson from "./pages/curriculum/CLesson";

import StudentData from "./pages/studentData/StudentData";
import ClassList from "./pages/classList/ClassList";
import CalculateFees from "./components/CalculateFees";
import Target from "./pages/target/Target";
import Marketing from "./pages/marketing/Marketing";
import Pending2 from "./pages/pending2/Pending2";
import Survey from "./pages/survey/Survey";
import CheckBills from "./pages/checkBills/CheckBills";
import Observation from "./pages/observation/Observation";


import Financial from "./pages/financial/Financial";

import Projection from "./pages/projection/Projection";

import Humanresources from "./pages/humanResources/Humanresources";

import Notifications from "./pages/notifications/Notifications";

import LeaveApprovals from "./pages/leaveApprovals/LeaveApprovals";



import Books from "./pages/Books/Books";

import TimeTable2 from "./pages/timetable/TimeTable2";

import CareReport from "./pages/careReport/CareReport";


import Resale from "./pages/Resale/Resale";

import AddNewStudent from "./pages/AddNewStudent/AddNewStudent";
import CheckPhone from "./pages/AddNewStudent/CheckPhone";

import SyllabusContainer from "./pages/Syllabus/SyllabusContainer";

/* import Test from "./pages/Test/Test"; */

import Dayplan from "./pages/DayPlan/Dayplan.jsx";
import LessonPlanning from "./pages/feedback/LessonPlanning";
import SyllabusMissing from "./pages/Syllabus/SyllabusMissing";

import Preparation from "./pages/Preparation/Preparation";




import RecentStopped from "./pages/Recent stopped/RecentStopped";

import TeachersReport from "./pages/Teachers report/TeachersReport";



import StoppedSearch from "./pages/Stopped search/StoppedSearch";




import Issues from "./pages/Issues/Issues.tsx";

















import Materials from "./pages/Materials/Materials.tsx";

import UnitReport from "./pages/UnitReport/UnitReport.tsx";


import BookList from "./pages/booklist/BookList.jsx";
import OperationsManualPage from "./pages/manual/Manual.jsx";
import Pipeline from "./pages/pipeline/Pipeline.jsx";
import PipelineReport from "./pages/pipeline/PipelineReport.jsx";
/* import Roadmap from "./pages/roadmap/index.jsx"; */

export default function Content(p) {
  /*  const [users, setUsers] = React.useState([]); */

  /*  React.useEffect(() => {
    p.net.get("/users").then((json) => {
      setUsers(json);
    });
  }, [p.net]); */
  /*  if (users.length === 0 || Object.keys(p.init) === 0)
    return <div>Loading...</div>; */

  /*  if (p.init === undefined) return <Loading />; */
  if (!p.center) return <Loading />;

  return (
    <div
      style={{
        padding: "15px",
        width: "100%",
        height: "92vh",
        overflowY: "auto",
      }}
    >
      <Routes>
        <Route
          path="/"
          element={<Home />}
        />
        <Route
          path="/days/:startOfWeek"
          element={<Home />}
        />
        
        <Route
          path="/fee"
          element={<CalculateFees />}
        />
        
        <Route
          path="/student-data"
          element={<StudentData />}
        />
        <Route
          path="/timetable"
          element={<TimeTable2 />}
        />
        <Route
          path="/timetable/:week"
          element={<TimeTable2 />}
        />
     
        <Route
          path="/placement-tests"
          element={<PlacementTests />}
        />
        {/*  <Route
          path="/curriculum"
          element={<Curriculum />}
        />
        <Route
          path="/curriculum/:id"
          element={<Syllabus />}
        /> */}
        {/*  <Route
          path="/curriculum/:id/unit/:uid"
          element={<Unit />}
        /> */}
        <Route
          path="/curriculum/:id/unit/:uid/lesson/:lid"
          element={<CLesson />}
        />
        <Route
          path="/class/:id/:classType/:unitId/:lessonId"
          element={
            <HtClass
              center={p.center}
              language={p.language}
              user={p.user}
            />
          }
        />
        <Route
          path="/class/:id/:classType/:unitId"
          element={
            <HtClass
              center={p.center}
              language={p.language}
              user={p.user}
            />
          }
        />
        <Route
          path="/class/:id/"
          element={
            <HtClass
              center={p.center}
              language={p.language}
              user={p.user}
            />
          }
        />
        <Route
          path="/attendance"
          element={
            <Attendance
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />

        <Route
          path="/staffshifts/:tDate"
          element={<StaffShifts center={p.center} />}
        />
        <Route
          path="/students"
          element={<Students />}
        >
          {/*  <Route
            path=":id"
            exact={true}
            element={<Student net={p.net} init={p.init} />}
          /> */}
        </Route>
        <Route
          path="/money"
          element={
            <Money
              /* init={p.init} */ user={p.user}
              center={p.center}
              l={p.l}
              language={p.language}
            />
          }
        />

        <Route
          path="/owed"
          element={<Owed />}
        />
        <Route
          path="/absent"
          element={
            <Absent
              user={p.user}
              language={p.language}
              l={p.l}
              center={p.center}
            />
          }
        />
        <Route
          path="/absent2"
          element={<Absent2 />}
        />
        <Route
          path="/need-makeup-classes"
          element={<NeedMakeUp />}
        />
        <Route
          path="/noshows"
          element={
            <NoShows
              user={p.user}
              language={p.language}
            />
          }
        />
        
        <Route
          path="/classlist"
          element={<ClassList />}
        />
        <Route
          path="/feedback/:lessonId"
          element={
            <AttendanceFeedback
              user={p.user}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/feedback2/:lessonId"
          element={<LessonPlanning />}
        />
        {/*    <Route
          path="/lessonplan/:lessonId"
          element={
            <LessonPlan
              user={p.user}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        /> */}
        <Route
          path="/mystudents"
          element={<Mystudent />}
        />
        <Route
          path="/marketingcampaigns"
          element={<Campaigns />}
        />
        <Route
          path="/newcustomer"
          element={
            <NewCustomer
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/newstudent/:customerId"
          element={
            <NewStudent
              /*  init={p.init} */
              /*  user={p.user}
              language={p.language}
              l={p.l} */
              {...p}
            />
          }
        />
        <Route
          path="/sales/messages"
          element={
            <SalesMessages
              user={p.user}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/sales/students"
          element={
            <SalesStudents
              user={p.user}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />

        <Route
          path="/sales/pending"
          element={<Pending {...p} />}
        />
      
        {/*  <Route
          path="/messages/:id"
          element={
            <ShowMessage
              user={p.user}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        /> */}
        <Route
          path="/sales/payment-frequency"
          element={
            <PaymentFrequency
              user={p.user}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/sales/payment-frequency/:date"
          element={<Navigate to="/sales/payment-frequency" replace />}
        />
        {/*   <Route
          path="/sales/next-payment"
          element={<NextPayment />}
        /> */}

      
        <Route
          path="/sales/cold-data"
          element={
            <ColdData
              user={p.user}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />

        <Route
          path="/sales/ready-for-class"
          element={<ReadyForClass />}
        />
        <Route
          path="/customer/:id/paymenthistory"
          element={
            <PaymentHistory
              user={p.user}
              language={p.language}
              l={p.l}
            />
          }
        />

        <Route
          path="/customer/:id"
          element={
            <Customer
              user={p.user}
              language={p.language}
              l={p.l}
              center={p.center}
            />
          }
        />
        <Route
          path="/student/:id"
          element={<Student />}
        />
        <Route
          path="/student/:id/:tab"
          element={<Student />}
        />
        <Route
          path="manage/overview"
          element={<Overview center={p.center} />}
        />
        <Route
          path="/manage/staff"
          element={
            <Staff
              user={p.user}
              net={p.net}
            />
          }
        />
        <Route
          path="/manage/staff/:id"
          element={
            <StaffMember
              user={p.user}
              net={p.net}
              center={p.center}
            />
          }
        />
        <Route
          path="/manage/feedback"
          element={
            <ManageFeedback
              user={p.user}
              net={p.net}
              center={p.center}
            />
          }
        />
        <Route
          path="/manage/makeupclasses"
          element={
            <MakeUpClasses
              user={p.user}
              net={p.net}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/manage/makeupclasses/timetable"
          element={
            <TimeTable
              user={p.user}
              net={p.net}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />

        <Route
          path="/manage/makeupclasses/detail/:id"
          element={
            <MakeUpClassDetails
              user={p.user}
              net={p.net}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />

        <Route
          path="/profile"
          element={
            <Profile
              user={p.user}
              setUser={p.setUser}
              net={p.net}
              center={p.center}
            />
          }
        />
        <Route
          path="/profile/:tab"
          element={
            <Profile
              user={p.user}
              setUser={p.setUser}
              net={p.net}
              center={p.center}
            />
          }
        />
        {/*  <Route
          path="/fixbills"
          element={
            <FixBills
              user={p.user}
              setUser={p.setUser}
              net={p.net}
              center={p.center}
            />
          }
        /> */}
        <Route
          path="/manage/messages"
          element={
            <ManageMessages
              user={p.user}
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/manage/settings"
          element={
            <Settings
              center={p.center}
              setCenter={p.setCenter}
              l={p.l}
              language={p.language}
            />
          }
        ></Route>
        <Route
          path="/manage/settings/:setting"
          element={
            <Settings
              /* init={p.init} */ center={p.center}
              setCenter={p.setCenter}
            />
          }
        />
     
        {/*  <Route
          path="/manage/reports"
          element={
            <Reports
              center={p.center}
              language={p.language}
              l={p.l}
              user={p.user}
            />
          }
        /> */}
        {/*  <Route
          path="/manage/classes"
          element={
            <ManageClasses
              center={p.center}
              net={p.net}
              l={p.l}
              language={p.language}
            />
          }
        /> */}
        <Route
          path="sales/survey"
          element={<Survey />}
        />
     
        <Route
          path="/manage/classes/report"
          element={
            <ClassesReport
              center={p.center}
              net={p.net}
            />
          }
        />
        
        {/*  <Route
          path="/manage/newlost"
          element={
            <NewLostStudents
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        /> */}
        <Route
          path="/newlost/:page/:year/:month"
          element={<NewLostStudents />}
        />
        {/*  <Route
          path="/newlost/:page/"
          element={
            <NewLostStudents
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        /> */}
        <Route
          path="/manage/salaries"
          element={
            <Salaries
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/manage/users"
          element={
            <Users
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        {/*   <Route
          path="/manage/pricing"
          element={<Pricing />}
        /> */}
        <Route
          path="/manage/costs"
          element={<Costs />}
        />
        <Route
          path="/manage/student-changes"
          element={<StudentChanges />}
        />
        
        <Route
          path="/manage/observations"
          element={<Observation />}
        />
        <Route
          path="/accounting"
          element={
            <Accounting
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/accounting/billing"
          element={
            <Billing
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/owner/stafflist"
          element={
            <StaffList
              center={p.center}
              setCenter={p.setCenter}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/owner/stafftree"
          element={
            <OrgTree
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />

       
        <Route
          path="/tech/revenue-today"
          element={
            <RevenueToday
              center={p.center}
              language={p.language}
              l={p.l}
            />
          }
        />
        <Route
          path="/manage/overview2"
          element={<Overview2 />}
        />
        <Route
          path="/manage/overview2/addsalarystat"
          element={<SalaryStat />}
        />
        <Route
          path="/extra-classes"
          element={<ExtraClass />}
        />
        <Route
          path="/target"
          element={<Target />}
        />
        <Route
          path="/marketing"
          element={<Marketing />}
        />
       
        <Route
          path="/pending"
          element={<Pending2 />}
        />
        <Route
          path="/check-bills"
          element={<CheckBills />}
        />

        <Route
          path="/accounting/financial"
          element={<Financial />}
        />
        <Route
          path="/tech/projection"
          element={<Projection />}
        />
        <Route
          path="/manage/humanResources"
          element={<Humanresources />}
        />
        <Route
          path="/manage/leave-approvals"
          element={<LeaveApprovals />}
        />
        <Route
          path="/tech/notifications"
          element={<Notifications />}
        />
       
        <Route
          path="/admin/Books"
          element={<Books />}
        />
        <Route
          path="/teaching/syllabus"
          element={<SyllabusContainer />}
        />
        <Route
          path="/teaching/syllabus/:syllabus"
          element={<SyllabusContainer />}
        />
        <Route
          path="/teaching/syllabus/:syllabus/unit/:unit"
          element={<SyllabusContainer />}
        />
        <Route
          path="/teaching/syllabus/:syllabus/unit/:unit/lesson/:lessonId"
          element={<SyllabusContainer />}
        />
        <Route
          path="/manage/care"
          element={<CareReport />}
        />
    
        
        <Route
          path="/sales/resale/:tab"
          element={<Resale />}
        />
      
        <Route
          path="/add-new-student/:phoneIn"
          element={<AddNewStudent />}
        />
      
      
      
        <Route
          path="/tech/DayPlan"
          element={<Dayplan />}
        />
        <Route
          path="/tech/DayPlan/:dt"
          element={<Dayplan />}
        />
        <Route
          path="/syllabus-missing/:id"
          element={<SyllabusMissing />}
        />
        <Route
          path="/teaching/preparation"
          element={<Preparation />}
        />
       
       
        <Route
          path="/recent-stopped/:classid"
          element={<RecentStopped />}
        />
        <Route
          path="/manage/teachers-report"
          element={<TeachersReport />}
        />
        
       
        <Route
          path="/sales/stopped-search"
          element={<StoppedSearch />}
        />
       
       
        <Route
          path="/syllabus/issues"
          element={<Issues />}
        />
       
        
        <Route
          path="/teaching/materials"
          element={<Materials />}
        />
        <Route
          path="/tech/unit-report"
          element={<UnitReport />}
        />
       
        <Route
          path="/booklist"
          element={<BookList />}
        />
        <Route
          path="/manual"
          element={<OperationsManualPage/>}
        />
        <Route
          path="/sales/pipeline"
          element={<Pipeline />}
        />
        <Route
          path="/manage/pipeline-report"
          element={<PipelineReport />}
        />
        {/*  <Route
          path="/tech/roadmap"
          element={<Roadmap />}
        /> */}
      </Routes>
    </div>
  );
}
